const DRAWING_FEEDBACK_DURATION_MS = 2000;

let drawingFeedbackTimer = 0;

function showDrawingFeedback(message, state = 'success', durationMs = DRAWING_FEEDBACK_DURATION_MS) {
  const target = document.getElementById('drawingFeedback');
  if (!target) return false;
  if (drawingFeedbackTimer) window.clearTimeout(drawingFeedbackTimer);

  const safeState = state === 'error' ? 'error' : 'success';
  target.textContent = String(message || '');
  target.dataset.state = safeState;
  target.setAttribute('role', safeState === 'error' ? 'alert' : 'status');
  target.hidden = false;

  const numericDuration = Number(durationMs);
  const duration = Number.isFinite(numericDuration) ? Math.max(0, numericDuration) : DRAWING_FEEDBACK_DURATION_MS;
  drawingFeedbackTimer = window.setTimeout(() => {
    target.hidden = true;
    drawingFeedbackTimer = 0;
  }, duration);
  return true;
}

export {
  DRAWING_FEEDBACK_DURATION_MS,
  showDrawingFeedback
};
